import { Component } from '@verndale/core';
import Headroom from 'headroom.js';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $displayTrigger: this.el._$('.community-nav-row__expand-trigger'),
      $panel: this.el._$('.community-nav-row__to-stick-panel'),
      $copyForm: _$('.share-popup'),
      $copyField: _$('.share-popup__input'),      
      $navLinks: this.el._$$('.community-nav-row__primary-link'),
    };

    this.expandedClass = 'community-nav-row--expanded';
    this.stick();
  }

  addListeners() {
    this.dom.$displayTrigger._on('click', this.handleDisplayTriggerClick.bind(this))
    this.dom.$copyForm._on('submit', this.handleCopyFormSubmit.bind(this))
    this.dom.$navLinks._on('click', this.handleLinkClick.bind(this))
  }

  handleDisplayTriggerClick() {
    const isExpanded = this.el.classList.contains(this.expandedClass);

    if (isExpanded) {
      this.collapse()
    } else {
      this.expand();
    }
  }

  handleListenToOutsidePrimaryNavPanel(e) {
    const hasClickedOutsidePanel = !this.dom.$panel.contains(e.target);

    if (hasClickedOutsidePanel) {
      this.collapse();
    }
  }

  handleCopyFormSubmit(e) {
    e.preventDefault();
    this.dom.$copyField.select();
    navigator.clipboard.writeText(this.dom.$copyField.value);
  }

  handleLinkClick(e) {
    e.preventDefault();

    var url = e.target.getAttribute('href');
    var eventId = e.target.getAttribute('data-event-id');

    const { Boxever, _boxever_settings } = window;

    if (!Boxever || !_boxever_settings || !eventId) {
      window.location = url;
      return;
    }

    const eventToSend = {
      channel: 'WEB',
      type: eventId,
      pos: window._boxever_settings.pointOfSale,
      browser_id: Boxever.getID()
    };

    Boxever.eventCreate(
      eventToSend,
      data => {
        window.location = url;
      },
      'json'
    );
  }

  expand() {
    this.el.classList.add(this.expandedClass);
    document._on('mousedown', this.handleListenToOutsidePrimaryNavPanel.bind(this));
  }

  collapse() {
    this.el.classList.remove(this.expandedClass);
    document.removeEventListener('click', this.handleListenToOutsidePrimaryNavPanel.bind(this));
  }

  stick() {
    new Headroom(this.el, {
      offset: this.el.offsetTop,
      classes : {
        initial : 'community-nav-row',
        pinned : 'community-nav-row--visible',
        unpinned : 'community-nav-row--hidden',
        top : '-',
        notTop : '-',
        bottom : '-',
        notBottom : '-',
        frozen: '-'
      }
    }).init();
  }
}

export default Module;
